import React from "react";

export default function PageNotFound() {
    return (<h1>404 page not found</h1>);
}